import React from 'react';
import { FaChevronRight, FaCommentAlt, FaPaperclip, FaRegClock } from 'react-icons/fa';
import { formatMaintenanceDate, maintenancePriorityLabel, maintenanceStatusLabel } from './MaintenancePageShell';

export default function MaintenanceTaskCard({ task, onOpen }) {
  return (
    <button type="button" className="maintenance-task-card" onClick={() => onOpen(task.id)}>
      <div className={`maintenance-task-card__priority priority-${Number(task.priority) || 0}`} aria-hidden="true" />
      <div className="maintenance-task-card__main">
        <div className="maintenance-task-card__topline">
          <span className="maintenance-task-card__reference">{task.reference || `#${task.id}`}</span>
          <span className={`maintenance-priority priority-${Number(task.priority) || 0}`}>{maintenancePriorityLabel(task.priority)}</span>
        </div>
        <h3>{task.title || 'Maintenance task'}</h3>
        <div className="maintenance-task-card__meta">
          <span className="maintenance-task-card__category">
            <strong>{task.category || 'No category'}</strong>
          </span>
          <span className={`maintenance-status status-${String(task.status || 'open').replace(/\s+/g, '-')}`}>{maintenanceStatusLabel(task.status)}</span>
        </div>
        <div className="maintenance-task-card__footer">
          <span className="maintenance-task-card__updated"><FaRegClock aria-hidden="true" /><span>Updated <span>{formatMaintenanceDate(task.last_activity_at || task.created_at)}</span></span></span>
        </div>
        <div className="maintenance-task-card__activity">
          <span className="maintenance-task-card__counts">
            <span className={Number(task.message_count) ? 'has-content' : ''}><FaCommentAlt aria-hidden="true" /> {Number(task.message_count || 0)} <span>comments</span></span>
            <span className={Number(task.attachment_count) ? 'has-content' : ''}><FaPaperclip aria-hidden="true" /> {Number(task.attachment_count || 0)} <span>files</span></span>
          </span>
          <span className="maintenance-task-card__open">View task <FaChevronRight aria-hidden="true" /></span>
        </div>
      </div>
    </button>
  );
}
